import React from 'react';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import Footer from '../landing-page/components/Footer';

const stats = [
  { value: '12K+', label: 'Topluluk Üyesi', icon: 'Users' },
  { value: '3+', label: 'Yıllık Deneyim', icon: 'Calendar' },
  { value: '50+', label: 'Etkinlik / Yıl', icon: 'Waves' },
  { value: '5+', label: 'Bayilik Sözleşmesi', icon: 'Award' },
];

const milestones = [
  {
    year: '2022',
    title: 'Kuruluş',
    desc: 'Sıfır Noktası bünyesinde PaddleTurkiye markası hayata geçirildi. İzmir merkezli küçük bir toplulukla başlayan yolculuğumuz, Türkiye genelinde hızla büyüdü.',
  },
  {
    year: '2023',
    title: 'Büyüme',
    desc: 'Türkiye\'nin dört bir yanında etkinlikler düzenledik. Topluluk üye sayımız 5.000\'i aştı. İlk bayilik anlaşmalarımızı imzaladık.',
  },
  {
    year: '2024',
    title: 'Liderlik',
    desc: 'Türkiye\'nin en büyük kürek sörfü platformu konumuna ulaştık. 12.000\'i aşkın aktif üye, 50\'den fazla yıllık etkinlik ve genişleyen marka anlaşmaları ağımızla sektörün referans noktası olduk.',
  },
];

const distributors = [
  { name: 'Red Paddle Co.', desc: 'İngiltere merkezli premium şişme SUP markasının Türkiye marka anlaşması' },
  { name: 'Starboard', desc: 'Dünya\'nın önde gelen SUP markalarından Starboard ürünleri' },
  { name: 'Fanatic', desc: 'Avusturya merkezli Fanatic SUP ve rüzgar sörfü ekipmanları' },
  { name: 'JP Australia', desc: 'Avustralya\'nın ikonik su sporları markası JP Australia' },
  { name: 'Naish', desc: 'Hawaii kökenli Naish SUP ve kite ekipmanları' },
];

const HakkimizdaPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-100">
      <Header />
      {/* Hero */}
      <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-900 to-gray-950 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-cyan-900/20 pointer-events-none" />
        <div className="max-w-7xl mx-auto relative">
          <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
            <Icon name="Waves" size={16} className="text-cyan-400" />
            <span className="text-cyan-400 text-sm font-medium">Hakkımızda</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Türkiye'nin Kürek Sörfü<br />
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              Referans Platformu
            </span>
          </h1>
          <p className="text-gray-400 text-lg md:text-xl max-w-3xl leading-relaxed">
            <strong className="text-white">PaddleTurkiye</strong>, <strong className="text-cyan-400">Sıfır Noktası</strong> bünyesinde tescil edilmiş bir markadır. 
            2022'den bu yana Türkiye'nin en kapsamlı kürek sörfü ekosistemini inşa ediyoruz: etkinlikler, spot rehberi, ekipman ve 12.000'i aşkın tutkulu bir topluluk.
          </p>
        </div>
      </section>
      {/* Stats */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-900/50">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats?.map((stat) => (
            <div key={stat?.label} className="bg-gray-900 rounded-2xl p-6 border border-gray-800 text-center">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                <Icon name={stat?.icon} size={24} className="text-cyan-400" />
              </div>
              <p className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">{stat?.value}</p>
              <p className="text-gray-400 text-sm mt-1">{stat?.label}</p>
            </div>
          ))}
        </div>
      </section>
      {/* Vision & Mission */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-5">
              <Icon name="Eye" size={24} color="white" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-4">Vizyonumuz</h2>
            <p className="text-gray-400 leading-relaxed">
              Türkiye'nin tüm kıyılarında ve iç sularında kürek sörfünü erişilebilir, güvenli ve topluluk odaklı bir yaşam biçimine dönüştürmek. 
              Sıfır Noktası olarak, suya özgürlük felsefemizle her bireyin doğayla buluşmasına köprü olmayı hedefliyoruz.
            </p>
          </div>
          <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-5">
              <Icon name="Target" size={24} color="white" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-4">Misyonumuz</h2>
            <p className="text-gray-400 leading-relaxed">
              Kaliteli ekipman marka anlaşmaları, profesyonel etkinlik organizasyonu ve güçlü dijital altyapıyla Türkiye'deki kürek sörfü topluluğunu büyütmek; 
              sporcuları, meraklıları ve markaları tek bir platformda buluşturmak.
            </p>
          </div>
        </div>
      </section>
      {/* Timeline */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900/30">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-3">3 Yıllık Başarı Hikayesi</h2>
            <p className="text-gray-400">PaddleTurkiye'nin kuruluşundan bugüne yolculuğu</p>
          </div>
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-px bg-gradient-to-b from-blue-500 to-cyan-500 hidden md:block" />
            <div className="space-y-8">
              {milestones?.map((m) => (
                <div key={m?.year} className="flex gap-6 items-start">
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center font-bold text-white text-sm z-10">
                    {m?.year}
                  </div>
                  <div className="bg-gray-900 rounded-2xl p-6 border border-gray-800 flex-1">
                    <h3 className="text-white font-bold text-lg mb-2">{m?.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{m?.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Distributors */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-3">Marka Anlaşmalarımız</h2>
            <p className="text-gray-400">Dünya'nın önde gelen su sporları markalarıyla marka anlaşmalarımız bulunmaktadır</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {distributors?.map((d) => (
              <div key={d?.name} className="bg-gray-900 rounded-2xl p-6 border border-gray-800 hover:border-cyan-500/40 transition-colors group">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-lg flex items-center justify-center mb-4 group-hover:from-blue-500/40 group-hover:to-cyan-500/40 transition-colors">
                  <Icon name="Package" size={20} className="text-cyan-400" />
                </div>
                <h3 className="text-white font-bold mb-2">{d?.name}</h3>
                <p className="text-gray-400 text-sm">{d?.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-blue-900/30 to-cyan-900/30">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Topluluğumuza Katılın</h2>
          <p className="text-gray-400 mb-8">12.000'i aşkın kürek sörfü tutkunuyla aynı dalgada buluşun.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/register" className="px-8 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-xl font-semibold hover:opacity-90 transition-opacity">
              Ücretsiz Kayıt Ol
            </a>
            <a href="/iletisim" className="px-8 py-3 bg-gray-800 text-white rounded-xl font-semibold hover:bg-gray-700 transition-colors border border-gray-700">
              İletişime Geç
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HakkimizdaPage;
